module.exports = __webpack_public_path__ + "img/ic_editdetail.f9391767.svg";